// #region Imports

import * as $ from "jquery";
import { largerThan } from './responsiveness';

// #endregion Imports

// #region Exports

export function initialize(): void {
    $('.js-read-more').click(readMoreHandler);
}

// #endregion Exports

// #region Private functions

function readMoreHandler(e) {
    e.preventDefault();
    const $this = $(this);
    const $root = $this.closest('.teaser');

    if(largerThan('tablet-landscape')) {
        fixateOffset($root.find('.teaser__media'));
        fixateOffset($root.find('.teaser__content'));
    }

    $this.hide();
    $this.next().removeClass('teaser__body--collapsed');
}

function fixateOffset($element: JQuery<HTMLElement>) {
    const offsetMedia = $element.position().top;
    $element.css('margin-top', offsetMedia);
    $element.css('align-self', 'auto');
}

// #endregion Private functions1
